import React, { useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  TextField,
  Tooltip,
  Typography,
  createSvgIcon,
  styled,
  Menu,
  MenuItem,
  Chip,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Calendar from "../../Icon/Calendar";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import MyLogoDropzone from "../../component/dropzone/LogoDropzone";
import CustomOutlinedSelect from "../../component/select field/OutlinedSelectField";
import CustomDataTable from "../../component/datatable/DataTable";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import Setting from "../../Icon/Setting";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAgentAction,
  GetCatalogAction,
  GetContractTypeAction,
  GetProgramAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import Message from "../../Icon/Message";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useNavigate, useParams } from "react-router-dom";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import {
  DeleteProgAvailableService,
  EditContractBlockedStatusService,
  EditProgAvailableService,
} from "../../Redux/service/SettingService";
import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import GlobalSearch from "../../component/sidebar/globalSearch";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const selectOptions = [
  { value: 10, label: "Option 1" },
  { value: 20, label: "Option 2" },
  { value: 30, label: "Option 3" },
];
const ProgramlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [Programlist, setProgramlist] = useState([]);

  const [isToggled, setIsToggled] = useState(false);

  const [table_load, setTable_load] = useState(false);

  const [isFilterOpen, setFilterOpen] = useState(false);

  const [Degreelist, setDegreelist] = useState([]);

  const [contractTypelist, setContractTypelist] = useState([]);

  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [deleteconfirmationopen, setDeleteConfirmationOpen] = useState(false);

  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [deleteId, setDeleteId] = useState();

  const [loading, setLoading] = useState(true);
  const [showContractAnchor, setShowContractAnchor] = useState(null);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  const handleShowContractClick = (event) => {
    setShowContractAnchor(event.currentTarget);
  };
  const handleShowContractClose = () => {
    setShowContractAnchor(null);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const ContractTypeListState = useSelector(
    (state) => state.setting?.contractType?.data
  );

  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (ContractTypeListState) {
      // const { data, pagination } = ContractTypeListState;
      // setRows(data);
      setPagination(ContractTypeListState?.pagination);
    }
  }, [ContractTypeListState]);

  // console.log(ContractTypeListState)

  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl + `/api/program/get-all-programs?${string.join("&")}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);

      setProgramlist(
        response?.data?.programs?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetContractTypeAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetContractTypeAction(data));
  };

  const handleApplyFilters = applyFilters;

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditContract/${params.row.id}`);
        };
        return (
          <Tooltip title="Edit Contract Type">
            {" "}
            <IconButton onClick={handleEditActionClick}>
              <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "contractType",
      headerName: "Contract Type",
      flex: 1,
      minWidth: 250,
      renderCell: (params) => {
        return <div>{params.row.contractType}</div>;
      },
    },

    {
      field: "isBlocked",
      headerName: "User Status",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            {window.sessionStorage.getItem("user_role_type") === "admin" && (
              <Tooltip title="Toggle block status for this contract type">
                <Box display="flex" alignItems="center" className="px-2">
                  <Chip
                    label={params.row.isBlocked === true ? "Blocked" : "Active"}
                    clickable
                    color={params.row.isBlocked === true ? "error" : "success"}
                    onClick={() => {
                      const newStatusBool = params.row.isBlocked === true ? false : true;
                      setChangeBlockStatusOfOrg({ id: params.row.id, isBlocked: newStatusBool ? "Y" : "N" });
                      setConfirmationOpen(true);
                      // optimistic update
                      setContractTypelist((prev) =>
                      	prev.map((data) =>
                          data.id === params.row.id ? { ...data, isBlocked: newStatusBool } : data
                        )
                      );
                    }}
                    sx={{ fontWeight: 600 }}
                  />
                </Box>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const fields = [
    {
      label: "Contract Type",
      value: "degree",
      type: "multi-select",
      option: Degreelist,
    },
  ];

  //(ProgramlistState, "catalog data");

  useEffect(() => {
    dispatch({ type: "GetContractList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    reload(data);
  }, []);

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    setTable_load(true);

    const updatedData = ContractTypeListState?.data?.map(
      ({ _id, ...rest }) => ({
        id: _id,
        ...rest,
      })
    );
    setContractTypelist(updatedData);
    setTable_load(false);
  }, [ContractTypeListState]);

  // Handle toggle change
  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    let data = {
      page: 1,
      limit: 25,
    };
    reload(data, newToggleState);
    // if (newToggleState) {
    //   setContractTypelist(
    //     AgentlistState?.blockedAgents?.map(({ _id, ...rest }) => ({
    //       id: _id,
    //       ...rest,
    //     }))
    //   );
    // } else {
    //   setContractTypelist(
    //     AgentlistState?.activeAgents?.map(({ _id, ...rest }) => ({
    //       id: _id,
    //       ...rest,
    //     }))
    //   );
    // }
    setIsToggled(newToggleState);
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={6} md={5} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Contract Type List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} md={7} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>

                <OutlineCustomButton
                  variant="contained"
                  type="button"
                  backgroundColor={ThemeColor.WHITE}
                  color={ThemeColor.BLACK}
                  onClick={handleShowContractClick}
                  sx={{ textTransform: 'none', px: 1, width: "auto" }}
                >
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: ThemeColor.BLACK }}>
                    Showing Contracts
                  </Typography>
                </OutlineCustomButton>
                <Menu
                  id="show-contract-menu"
                  anchorEl={showContractAnchor}
                  open={Boolean(showContractAnchor)}
                  onClose={handleShowContractClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <MenuItem
                    onClick={() => {
                      let data = { page: 1, limit: 50 };
                      reload(data, false);
                      setIsToggled(false);
                      handleShowContractClose();
                    }}
                  >
                    <Chip label="Active" color="success" />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      let data = { page: 1, limit: 50 };
                      reload(data, true);
                      setIsToggled(true);
                      handleShowContractClose();
                    }}
                  >
                    <Chip label="Blocked" color="error" />
                  </MenuItem>
                </Menu>
              </Box>
            </Grid>
          </Grid>

          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={contractTypelist ? contractTypelist : []}
              columns={columns}
              loading={table_load}
              minTableWidth="100%"
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />

          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setContractTypelist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isBlocked:
                        changeBlockStatusOfOrg.isBlocked === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditContractBlockedStatusService(
                  changeBlockStatusOfOrg
                );

                if (res.status === 200) {
                  // let data = {
                  //   page: 1,
                  //   limit: 2,
                  // };
                  let data = {
                    page: 1,
                    limit: 25,
                  };
                  reload(data, isToggled);
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Do you wish to block the contract type?"}
          />
          {/* <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setProgramlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                        ...data,
                        isAvailable: changeBlockStatusOfOrg.isAvailable,
                      }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditProgAvailableService(
                  changeBlockStatusOfOrg.isAvailable,
                  changeBlockStatusOfOrg.id
                );

                if (res.status === 200) {
                  dispatch(GetProgramAction(id));
                  setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          /> */}

          {/* for delete */}
          {/* <ConfirmationModal
            msg="Delete"
            btnName="Delete"
            handleConfirmationClose={() => {
              setDeleteConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await DeleteProgAvailableService(deleteId);

                if (res.status === 200) {
                  dispatch(GetProgramAction(id));
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={deleteconfirmationopen}
            message={"Want to delete the program?"}
          /> */}
        </>
      )}
    </div>
  );
};

function ContractTypeList() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    dispatch(GetContractTypeAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<ProgramlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default ContractTypeList;
